import Backbone from "backbone";
import $ from "jquery";
import { MagnificPopup } from "../../../Assets/javascripts/common/dynamic-imports/MagnificPopup";
import SymbolTemplate from "../../../Assets/templates/Symbol.mustache";
import {symbolsURL} from "../../../Assets/javascripts/common/others/Configuration";

export default Backbone.View.extend({
    initialize: function () {
      this.status = this.$el.attr("data-status-id");
    },

    events: {
      "click": "showPopup"
    },

    showPopup: function () {

    },

    render: function () {
      // if html present then add it to popup content
      // else add load to popup content and fetch html
      const magnificPopup = new MagnificPopup();
      if (this.model.get('html')) {
        magnificPopup.open({ items: { src: this.model.get('html') } });
      } else {
        magnificPopup.open({ items: { src: SymbolTemplate.render({ClassName: "mfp__loader", SymbolsUrl: symbolsURL, SymbolName: "icon_i_290_loader"}) } });
        this.model.fetch();
      }
    }
  });
